import store from '../stores/store';

export function getAuthHeader() {
  if (store.getters.getVal('sessionExists')) {
    return store.getters.getVal('authHeader');
  } else {
    return null;
  }
}

export function getCalendarPeriod() {
  return store.getters.getVal('calendarPeriod');
}


export default {
  getAuthHeader,
  getCalendarPeriod,
};